module.exports = __webpack_public_path__ + "img/z-image-turbo.18fb6cdf.jpg";